import { render, staticRenderFns } from "./adjust.vue?vue&type=template&id=705aa0a2&scoped=true"
import script from "./adjust.vue?vue&type=script&lang=js"
export * from "./adjust.vue?vue&type=script&lang=js"
import style0 from "./adjust.vue?vue&type=style&index=0&id=705aa0a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705aa0a2",
  null
  
)

export default component.exports